<template>
	<div class="col-xl-9">
		<div class="card">
			<div class="card-body">
				<h5 class="header-title mb-12">
					<i class="fas fa-users"></i> 
						Listado Alumnos
				</h5>
				<small>
					A continuación, verás el listado de alumnos inscritos en el
					curso.
				</small>
				<v-client-table
					:data="jsonAlumno"
					:columns="columnsTable"
					:options="options"
					v-if="!activeEvaluacion"
				>
					<div
						v-for="(value, key) in this.jsonEvaluacion"
						:slot="value.nombreEvaluacion"
						slot-scope="data"
						:key="key"
					>
						<div
							v-for="(valueEvaluacion, keyEv) in data.row
								.evaluacion"
							:key="keyEv"
						>
							<div
								v-if="
									valueEvaluacion.idEvaluacion ===
										value.idEvaluacion
								"
							>
								<div v-if="valueEvaluacion.nota != '-'">
									<label
										v-if="valueEvaluacion.nota < 4"
										style="color:red;"
									>{{ (Math.round(valueEvaluacion.nota * 100) / 100).toFixed(1) }}
									<!-- <b-button variant="primary"><b-icon icon="arrow-counterclockwise" animation="spin-reverse-pulse" font-scale="1"></b-icon></b-button> -->
									</label>
									<label v-else>
										{{ (Math.round(valueEvaluacion.nota * 100) / 100).toFixed(1) }}
									</label>
								</div>
								<div v-else>
									{{ valueEvaluacion.nota }}
								</div>
							</div>
						</div>
					</div>
					<div slot="reiniciar" slot-scope="data">
						<div v-if="data.row.evaluacion[0].nota < 4" style="text-align: center;">
                             <b-button variant="primary" v-b-modal.modal-reinicioEvaluacion @click="modalEvaluacion(data.row,data.row.evaluacion[0].idEvaluacion)"><b-icon icon="arrow-counterclockwise" animation="spin-reverse-pulse" font-scale="1"></b-icon></b-button>
						</div>
						<div v-else style="text-align: center;">
                             <span>---</span>
						</div>
					</div>
					<div slot="estado" slot-scope="props">
						<b-badge 
							variant="danger" 
							v-if="props.row.estado == 0">
							Reprobado
						</b-badge>
						<b-badge 
							variant="success" 
							v-if="props.row.estado == 1">
							Aprobado
						</b-badge>
						<b-badge 
							variant="info" 
							v-if="props.row.estado == 2">
							Pendiente
						</b-badge>
					</div>
				</v-client-table>
				<PuSkeleton v-else :count="5"></PuSkeleton>

				<reinicioEvaluacion />
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import reinicioEvaluacion from "../curso/modal/reinicioEvaluacion";
export default {
	components: {
		reinicioEvaluacion,
	},
	data: () => ({
		options: {
			headings: {
				numeroDocumento: "Rut",
				nombreAlumno: "Nombre Alumno",
				promedioFinal:'Promedio Final',
			},
			sortable: ["nombre", "numeroDocumento"],
			filterable: ["nombre", "numeroDocumento"],
		},
		dataAlumno: [],
	}),
	computed: {
		...mapState("alumno", ["jsonAlumno"]),
		...mapState("evaluacion", ["jsonEvaluacion"]),
		...mapState('evaluacion',['activeEvaluacion']),
		columnsTable() {
			return ["numeroDocumento", "nombreAlumno"].concat(
				this.jsonEvaluacion.map((ev) => ev.nombreEvaluacion).concat(["promedioFinal","reiniciar","estado"])
			);
		},
	},
	methods: {
		...mapActions("alumno", ["addActiveAlumno"]),
		modalEvaluacion(props,idEvaluacion) {
			this.addActiveAlumno({...props,idEvaluacion});
		},
	},
	mounted(){
        // console.log("mounted");
	},
};
</script>
